import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import get from 'lodash/get';
import some from 'lodash/some';
import reduce from 'lodash/reduce';
import remove from 'lodash/remove';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { url } from '../../helpers/Utils/url';
import SiteComponent from '../SiteComponent/SiteComponent';
import actions from '../../actions/CustomOptionsAction';
import * as styles from './CustomOptions.css';
import CustomOptionsInput from './CustomOptionsInput';
import CustomOptionsDropdown from './CustomOptionsDropdown';
import { selectFeatureFlags } from '../../selectors/ContextSelector';
import { initProductOptions, selectedProductSkus } from '../../selectors/ProductOptionsSelector';
import AnalyticsAction from '../../actions/AnalyticsAction';
import pricingAction from '../../actions/ProductPricingAction';
import { removeAllMessages } from '../../actions/MessagesAction';
import selectCustomOptionsInitialValues from '../../selectors/CustomOptionsSelector';
import productConstants, { CUSTOM_OPTIONS_TYPE_TOKEN } from '../../common/ProductConstants';
import ProductOptionPills from '../ProductOptionPills/ProductOptionPills';

const { MADE_TO_MEASURE, HEMMING } = productConstants;
const cx = classNames.bind(styles);
let requiredCustomOptions = [];

const preparePricingURL = (customOptionsSelected, ppId, itemOfferings, customizationType) => {
    let requiredOptionsSelected = false;
    let requiredCustomOptionsSelectedLength = 0;
    const qparams = reduce(
        customOptionsSelected,
        (result, customOption) => {
            const { type, value } = customOption;
            result[type] = value;
            if (!isEmpty(value)) {
                requiredCustomOptionsSelectedLength += some(requiredCustomOptions, { name: type })
                    ? 1
                    : 0;
            }
            return result;
        },
        { ppId }
    );

    requiredOptionsSelected = requiredCustomOptionsSelectedLength === requiredCustomOptions.length;
    /* istanbul ignore next */
    const pricingUrl = requiredOptionsSelected && itemOfferings.URL ? itemOfferings.URL : '';
    return {
        itemOfferingCall: requiredOptionsSelected,
        qparams,
        URL: pricingUrl,
        customizationType,
    };
};

/* istanbul ignore next */
const getSelectedCustomOptionsWithoutColor = ({
    query,
    customOptions: { selectedCustomOptions, options },
}) => {
    let customOptions = [];
    if (!isEmpty(query) && options) {
        requiredCustomOptions = options.fields && options.fields.filter((field) => field.required);
        const queryOptions = [];
        options.fields &&
            options.fields.forEach((field) => {
                if (query[field.name] && !some(selectedCustomOptions, ['nameType', field.type])) {
                    queryOptions.push({
                        type: field.name,
                        value: query[field.name],
                        nameType: field.type,
                        maxValue: field.maxValue ? field.maxValue : null,
                    });
                }
            });
        customOptions = selectedCustomOptions
            ? [...queryOptions, ...selectedCustomOptions]
            : queryOptions;
    } else {
        customOptions = selectedCustomOptions || [];
    }
    return customOptions.filter((option) => option.type !== 'COLOR');
};

const disableLabels = {
    // Disable MTM fraction field Label display if WD field is set as maximum
    [CUSTOM_OPTIONS_TYPE_TOKEN.WDF]: 'Fraction',
    // Disable MTM fraction field Label display if LN field is set as maximum
    [CUSTOM_OPTIONS_TYPE_TOKEN.LNF]: 'Fraction',
};

/* istanbul ignore next */
export class CustomOptions extends SiteComponent {
    static defaultProps = {
        customOptions: {},
        selectedProductOptions: [],
        selectedProduct: [],
        ppId: null,
        dataAutomationId: '',
        actions: {},
        productOptions: {},
        customizationModel: {},
        query: {},
        messagesTexts: {},
        messages: {},
        location: {},
        router: {},
        initialValues: {},
        featureFlags: {},
        itemOfferings: {},
        deviceType: {},
        fromMiniPDP: false,
        isATCClicked: false,
    };

    static propTypes = {
        dataAutomationId: PropTypes.string,
        customOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        selectedProductOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedProduct: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        ppId: PropTypes.string,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        customizationModel: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        query: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.object,
        messagesTexts: PropTypes.object,
        messages: PropTypes.object,
        location: PropTypes.object,
        router: PropTypes.object,
        initialValues: PropTypes.object,
        itemOfferings: PropTypes.object,
        deviceType: PropTypes.object,
        fromMiniPDP: PropTypes.bool,
        isATCClicked: PropTypes.bool,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: '',
            disabledCustomOptionsIds: [],
        };
        this.textValidators = {};
        this.dropdownValidators = {};
        this.optionsOnChange = this.optionsOnChange.bind(this);
    }

    componentDidMount() {
        const {
            selectedProduct,
            actions: { getCustomOptionsAction },
        } = this.props;
        if (selectedProduct && selectedProduct[0] && selectedProduct[0].customizationModel) {
            const { pathname } = url(selectedProduct[0].customizationModel.href);
            getCustomOptionsAction(pathname);
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            actions: {
                clearProductPricingAction,
                getCustomOptionsAction,
                removeAllMessages: removeAllMessagesAction,
            },
        } = this.props;
        const { itemOfferings: itemOfferingsNextProps } = nextProps;
        if (!isEqual(nextProps.selectedProduct, this.props.selectedProduct)) {
            if (
                nextProps.selectedProduct &&
                nextProps.selectedProduct[0] &&
                nextProps.selectedProduct[0].customizationModel
            ) {
                const { pathname } = url(nextProps.selectedProduct[0].customizationModel.href);
                if (
                    get(nextProps, 'selectedProduct[0].customizationModel.href', '') !==
                    get(this.props, 'selectedProduct[0].customizationModel.href', '')
                ) {
                    removeAllMessagesAction({
                        section: 'CUSTOM_OPTIONS_FORM',
                        sourceMiniPDP: false,
                    });
                }
                getCustomOptionsAction(pathname);
            }
        }
        if (
            !isEqual(
                nextProps.customOptions.selectedCustomOptions,
                this.props.customOptions.selectedCustomOptions
            ) ||
            (!isEmpty(nextProps.query) && !nextProps.customOptions.selectedCustomOptions) ||
            !isEqual(nextProps.selectedProductOptions, this.props.selectedProductOptions)
        ) {
            const selectedColorOption = nextProps.selectedProductOptions.filter(
                (productOption) => productOption.type === 'COLOR'
            );
            const selectedCustomOptionsWithoutColor = getSelectedCustomOptionsWithoutColor(
                nextProps
            );
            const { customizationModel } = this.props;
            let optionsSelected = [...selectedCustomOptionsWithoutColor];
            if (selectedColorOption.length) {
                optionsSelected = [
                    ...selectedCustomOptionsWithoutColor,
                    {
                        type: selectedColorOption[0].type,
                        value: selectedColorOption[0].name,
                        nameType: 'COL',
                        maxValue: null,
                    },
                ];
            }
            if (!isEmpty(nextProps.customOptions.options)) {
                const pricingURL = preparePricingURL(
                    optionsSelected,
                    nextProps.ppId,
                    itemOfferingsNextProps,
                    customizationModel.type
                );
                pricingURL.itemOfferingCall &&
                    this.props.actions.customOptionsOnChange({
                        options: nextProps.customOptions.options,
                        selectedCustomOptions: [...optionsSelected],
                        pricingURL,
                    });
                // When itemOfferingCall is false product pricing to be cleared to avoid showing delivery options.
                !pricingURL.itemOfferingCall && clearProductPricingAction(false);
            }
        }
    }

    /* istanbul ignore next */
    optionsOnChange(option, event) {
        const { value } = event.target;
        const {
            ppId,
            customOptions: { options, selectedCustomOptions },
            itemOfferings,
            customizationModel,
        } = this.props;
        let optionsSelected = selectedCustomOptions
            ? selectedCustomOptions.filter((selectedOption) => selectedOption.type !== option.name)
            : [];
        /* istanbul ignore next */
        if (option.inputType === 'TEXT' && option.maxValue === parseInt(value, 10)) {
            optionsSelected = optionsSelected.filter(
                (optionSelected) => optionSelected.nameType !== `${option.type}F`
            );
        }
        optionsSelected.push({
            type: option.name,
            value,
            nameType: option.type,
            maxValue: option.maxValue ? option.maxValue : null,
        });
        if (
            !this.state.selectedValue &&
            selectedCustomOptions &&
            selectedCustomOptions.findIndex((element) => element.type === 'MOUNT') === -1 &&
            options.type !== 'PER'
        ) {
            optionsSelected = [
                ...optionsSelected,
                {
                    type: 'MOUNT',
                    value: 'INSIDE',
                    nameType: 'MNT',
                    maxValue: null,
                },
            ];
        }
        this.props.actions.customOptionsOnChange({
            options,
            selectedCustomOptions: [...optionsSelected],
            pricingURL: preparePricingURL(
                optionsSelected,
                ppId,
                itemOfferings,
                customizationModel.type
            ),
        });
    }

    onChangeHandler(dimension, dataItem, value) {
        const {
            ppId,
            customOptions: { options, selectedCustomOptions },
            itemOfferings,
            customizationModel,
        } = this.props;
        dataItem =
            dataItem || (dimension && dimension.options.filter((item) => item.value === value));
        let optionsSelected = selectedCustomOptions ? [...selectedCustomOptions] : [];
        if (dataItem.length) {
            const shouldOptionsUpdate = !find(
                selectedCustomOptions,
                (option) => option.type === dimension.name && dataItem[0].name === option.value
            );
            if (shouldOptionsUpdate) {
                const modifiedCustomOption = remove(
                    selectedCustomOptions,
                    (option) => option.type !== dimension.name
                );
                optionsSelected = [
                    ...modifiedCustomOption,
                    {
                        type: dimension.name,
                        value: dataItem[0].name,
                        nameType: dimension.type,
                        maxValue: null,
                    },
                ];
            }
        }
        this.props.actions.customOptionsOnChange({
            options,
            selectedCustomOptions: [...optionsSelected],
            pricingURL: preparePricingURL(
                optionsSelected,
                ppId,
                itemOfferings,
                customizationModel.type
            ),
        });
        this.setState({
            selectedValue: dataItem[0].name,
        });
    }

    disableFraction = (fractionType = '', disable = false) => {
        let fieldToChange = '';
        switch (fractionType) {
            case CUSTOM_OPTIONS_TYPE_TOKEN.LN:
                fieldToChange = CUSTOM_OPTIONS_TYPE_TOKEN.LNF;
                break;
            case CUSTOM_OPTIONS_TYPE_TOKEN.WD:
                fieldToChange = CUSTOM_OPTIONS_TYPE_TOKEN.WDF;
                break;
            default:
                fieldToChange = '';
                break;
        }
        const field = find(get(this.props.customOptions, 'options.fields'), {
            type: fieldToChange,
        });
        if (field) {
            if (disable) {
                const disabledIDs = [...this.state.disabledCustomOptionsIds];
                disabledIDs.push(field.id);
                this.setState({ disabledCustomOptionsIds: disabledIDs });
            } else {
                const disabledIDs = [...this.state.disabledCustomOptionsIds].filter((item) => {
                    return item !== field.id;
                });
                this.setState({ disabledCustomOptionsIds: disabledIDs });
            }
        }
    };

    getDefaultValueSelected = (type) => {
        const {
            customOptions: { selectedCustomOptions },
        } = this.props;
        const selectedCustomOptionsValue = get(find(selectedCustomOptions, { type }), 'value', '');
        const selectedValue = this.state.selectedValue
            ? this.state.selectedValue
            : selectedCustomOptionsValue;
        return selectedValue;
    };

    checkOptionsWarning(customOptionType) {
        const {
            messages: { CUSTOM_OPTIONS_FORM = [], errorATCCustomBanner = null },
            featureFlags: { enableErrorSizing },
        } = this.props;
        if (CUSTOM_OPTIONS_FORM && errorATCCustomBanner && enableErrorSizing) {
            const errorCustom = CUSTOM_OPTIONS_FORM.find((item) => {
                const customType = item?.id.split('_');
                if (customType[customType.length - 1] === customOptionType) {
                    return true;
                }
                return false;
            });
            return !!errorCustom;
        }
        return null;
    }

    renderCustomOptions(
        dataItem,
        index,
        totalItems,
        personalizedItemType,
        personalize,
        personalRequired,
        mtm
    ) {
        const {
            messagesTexts: { CustomOptionsMessages },
            deviceType,
            messages,
            isATCClicked,
            customizationModel,
            featureFlags: { enableErrorSizing, disableFractionSizeSelection },
        } = this.props;
        let optionName = '';
        if (dataItem.required || (!personalize && !mtm)) {
            if (mtm) {
                optionName = dataItem.name.toLowerCase().split('-')[0];
            } else {
                optionName = dataItem.name.toLowerCase();
            }
        } else if (!mtm) {
            optionName = dataItem.name.toLowerCase();
        }
        let optionsBlock;
        if (dataItem.type === 'MNT') {
            optionsBlock = `sm12 md12 lg6 xl6 ${styles.optionsBlock} ${dt(['mt-4'])}`;
        } else if (mtm) {
            optionsBlock = `sm6 md6 lg3 xl3 ${styles.optionsBlock}`;
        } else {
            optionsBlock = `sm12 md12 lg6 xl6 ${styles.optionsBlock}`;
        }
        let label = null;
        if (mtm) {
            label = 'Inches';
        } else {
            label = dataItem.description;
        }
        let customOptions = null;
        let optionNameHTML = null;
        optionNameHTML = (
            <span className={dt(['flex'])}>
                <span
                    aria-label={optionName}
                    className={dt([
                        'inline-block',
                        'font-semibold',
                        'leading-[1.43]',
                        'text-sm',
                        this.checkOptionsWarning(dataItem.id) ? 'text-[#DC2626]' : 'text-black',
                    ])}
                >
                    {optionName}
                </span>
                {dataItem.inputType === 'TEXT' && mtm && dataItem.description.match(/\d+/g) && (
                    <span
                        className={dt([
                            'text-urgency-border',
                            'text-sm',
                            'pl-1',
                            'whitespace-nowrap',
                        ])}
                    >
                        {' '}
                        {dataItem.description.match(/\d+/g)[0]}" to{' '}
                        {dataItem.description.match(/\d+/g)[1]}"
                    </span>
                )}
            </span>
        );
        switch (dataItem.inputType) {
            case 'TEXT': {
                customOptions = [
                    <CustomOptionsInput
                        type="text"
                        className={cx(
                            'inputText',
                            this.checkOptionsWarning(dataItem.id) && 'inputerrorborder'
                        )}
                        placeholder={label}
                        onBlur={this.optionsOnChange.bind(this, dataItem)} // eslint-disable-line
                        validate={{
                            dataItem,
                            personalizedItemType,
                            optionName,
                            CustomOptionsMessages,
                        }}
                        maxRange={dataItem.maxRange}
                        title={optionNameHTML}
                        isPersonalize={personalRequired}
                        messageError={messages}
                        enableErrorSizing={enableErrorSizing}
                        isATCClicked={isATCClicked}
                        isMTM={customizationModel.type === MADE_TO_MEASURE}
                        disableFraction={this.disableFraction}
                    />,
                ];
                break;
            }
            case 'DROP_DOWN': {
                let disableLabel = '';
                const disableCustomOptions = this.state.disabledCustomOptionsIds.includes(
                    dataItem.id
                );
                if (disableCustomOptions) {
                    disableLabel = disableLabels[dataItem.type];
                }
                customOptions = (
                    <div>
                        {dataItem.type === 'MNT'
                            ? [
                                  <ProductOptionPills
                                      productOptions={dataItem}
                                      onOptionClick={this.onChangeHandler.bind(this)} // eslint-disable-line
                                      selectedOption={this.getDefaultValueSelected(dataItem.name)}
                                      clientRendering
                                      customOptions
                                  />,
                              ]
                            : [
                                  <CustomOptionsDropdown
                                      className={cx(
                                          this.checkOptionsWarning(dataItem.id) &&
                                              'inputerrorborder'
                                      )}
                                      dataItem={dataItem}
                                      onSelectOption={this.optionsOnChange}
                                      options={dataItem.options}
                                      validate={{
                                          personalizedItemType,
                                          optionName,
                                          CustomOptionsMessages,
                                      }}
                                      disableDropDown={disableCustomOptions}
                                      disableLabel={disableLabel}
                                      isPersonalize={personalRequired}
                                      customFlag
                                      ismtm={mtm}
                                      overrideDefaultValue={disableCustomOptions}
                                      messageError={messages}
                                      enableErrorSizing={enableErrorSizing}
                                      isATCClicked={isATCClicked}
                                      selectedOptions={
                                          this.props.customOptions.selectedCustomOptions
                                      }
                                      disableFractionSizeSelection={disableFractionSizeSelection}
                                  />,
                              ]}
                    </div>
                );
                break;
            }
            default:
                customOptions = null;
                break;
        }

        return (
            <div className={cx(optionsBlock)}>
                {dataItem.type === 'MNT' && (
                    <div
                        className={`${cx('row')} ${dt([
                            'capitalize',
                            'text-sm',
                            'font-normal',
                            'font-open-sans',
                            'min-h-[15px]',
                            'text-gray-70',
                            'sm:!mx-0',
                            'sm:!mb-2',
                        ])}`}
                    >
                        {optionNameHTML}
                    </div>
                )}
                {customOptions}
            </div>
        );
    }

    render() {
        // check for customization Model and before rendering.
        const { options } = this.props.customOptions;
        const { customizationModel } = this.props;
        const personalizedItem = customizationModel && customizationModel.type === HEMMING;
        let optionsSource = [];
        let personalRequired = false;
        let personalized = false;
        let mtm = false;
        if (customizationModel && options) {
            optionsSource = options.fields.filter((field) => field.type !== 'COL');
            requiredCustomOptions = options.fields.filter((field) => field.required);
            if (optionsSource.findIndex((element) => element.type === 'WD') === 0) {
                mtm = true;
            }
            if (
                optionsSource.findIndex((element) => element.name === 'PERSONALIZATION') === 0 ||
                (!mtm && optionsSource.findIndex((element) => element.name.split('-')[1]) === 0) ||
                optionsSource.findIndex((element) => element.name === 'BIRTHSTONES') === 0
            ) {
                if (optionsSource.filter((element) => element.required === true).length > 1) {
                    personalRequired = true;
                }
                personalized = true;
            }
            const customOptions = optionsSource.map((option, index) =>
                this.renderCustomOptions(
                    option,
                    index,
                    optionsSource.length,
                    personalizedItem,
                    personalized,
                    personalRequired,
                    mtm
                )
            );
            return (
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                    }}
                    className={`${dt(['mb-3', 'items-end'])} ${cx('CustomOptionsContainer')}`}
                    data-automation-id={this.props.dataAutomationId}
                >
                    {customOptions}
                </form>
            );
        }
        return null;
    }
}

const ConnectedCustomOptionsForm = connect(
    (state, ownProps) => ({
        customOptions: state.customOptions || [],
        deviceType:
            /* istanbul ignore next */
            state.context ? state.context.deviceType : {},
        selectedProductOptions: initProductOptions(ownProps.fromMiniPDP)(state).optionsSelected,
        messagesTexts: state.context.messagesTexts,
        messages: state.messages,
        initialValues: selectCustomOptionsInitialValues(state, ownProps.query),
        selectedProduct: selectedProductSkus(ownProps.fromMiniPDP)(state),
        featureFlags: selectFeatureFlags(state),
        isATCClicked: state.addToCart.atcOnClick || false,
    }),
    (dispatch) => ({
        actions: bindActionCreators(
            { ...actions, ...AnalyticsAction, ...pricingAction, removeAllMessages },
            dispatch
        ),
    })
)(CustomOptions);

export default withRouter(ConnectedCustomOptionsForm);
